import logo from "../images/logo.png";

const MobileInterface = () => {

  const cssVars = {
    '--top-offset': '5vh',                                          
    '--mid-nudge-up': 'clamp(0px, 4vh, 48px)',                      
    '--mid-title-gap': 'clamp(8px, 2vh, 16px)',                     
    '--mid-para-gap': 'clamp(12px, 3vh, 24px)',                    
    '--safe-bottom': 'max(0px, env(safe-area-inset-bottom))',      
  };

  const blurStyle = {
    position: "absolute",
    width: "100%",
    height: "200px",
    background: "#6379F5",
    opacity: 0.14,
    filter: "blur(50px)",
    zIndex: 0,
  };

  return (
    <div
      className="relative min-h-[100svh] grid grid-rows-[auto_1fr_auto] overflow-hidden"
      style={cssVars}
    >
      <div style={blurStyle} />

      <div className="absolute inset-0 bg-[#F9FAFC] z-[-200]" />

      <div
        className="absolute inset-x-0 bottom-0 w-full h-1/3 bg-cover bg-no-repeat bg-top pointer-events-none"
        style={{
          backgroundImage: `url(${require("../images/Image.png")})`,
          backgroundSize: "110% auto",
        }}
      />

      <header className="row-start-1 flex justify-center" style={{ marginTop: 'var(--top-offset)' }}>
        <img src={logo} alt="GrayFox Logo" className="h-10" />
      </header>

      <main className="row-start-2 place-self-center px-6 text-center -translate-y-[var(--mid-nudge-up)]">
        <h2 className="text-[18px] font-semibold text-[#38485C] mb-[var(--mid-title-gap)]">
          GrayFox is not yet supported on mobile browsers.
        </h2>
        <p className="text-[16px] text-[#38485C] max-w-xs mx-auto mb-[var(--mid-para-gap)]">
          To use <span className="font-semibold text-[#6A79F8]">GrayFox</span>,
          please log in on your computer via{" "}
          <a
            href="https://swag.grayfox.ma/login"
            className="text-[#38485C] font-semibold hover:underline"
          >
            app.grayfox.ma/login
          </a>
          , or download the GrayFox Android app from the Play Store.
        </p>
      </main>
    </div>
  );
};

export default MobileInterface;
